$( ->
  $('button, .button').on 'click', (e) ->
    if $(this).hasClass('disabled')
        e.preventDefault()
        e.stopPropagation()
)